import api from '../api';
import Axios from 'axios';
import { trackPromise } from 'react-promise-tracker';
import { GetFileExtension, getJwt, imageFormats } from '@app/helpers';

export interface Aditivo {
  id: string;
  contratoId: string;
  numero?: number;
  ordem?: number;
  dataTermino?: Date;
  dataTerminoFormatada?: string;
  tipoAditivo?: string;
  valor?: number;
  valorDiferenca?: number;
  sgc: boolean;
  pendenciaArquivo: boolean;
  pendenciaAvaliacao: boolean;
  statusAditivoId: string;
}

export interface StatusAditivo {
  id: string;
  nome: string;
  text: string;
  value: string;
}

export interface InfoAditivo {
  contratoId?: string;
  pendenciaAditivo?: boolean;
  pendenciaAditivoDescricao?: string;
  contratoNaoSeraAditado?: boolean;
}

export interface AditivoComArquivo {
  id: string;
  contratoId: string;
  numero?: number;
  ordem?: number;
  dataTermino?: string;
  dataTerminoFormatada?: string;
  tipoAditivo?: string;
  valor?: number;
  valorDiferenca?: number;
  arquivoContratoAditivos: ArquivoContratoAditivo[];
  valorFormatado: string;
  valorDiferencaFormatado: string;
}

export interface ArquivoContratoAditivo {
  id: string;
  extensao: string;
  local: string;
  nome: string;
  responsavel: string;
  dataInclusao: string;
  numero: number;
  dataInclusaoFormatada: string;
}

export const getAllAditivosByContrato = (id: any) => api.get<Aditivo[]>(`aditivos/contrato/${id}`);
export const getAllAditivosSgcByContratoId = (id: any) =>
  api.get<Aditivo[]>(`aditivos/getAllAditivosSgcByContratoId/${id}`);
export const getInformacaoAditivo = (id: any) => api.get<InfoAditivo>(`contratos/aditivos/info/${id}`);
export const getAllStatusAditivo = () => api.get<StatusAditivo[]>(`status/getAllStatusAditivo`);
export const getAllStatusAditivoOptions = () =>
  getAllStatusAditivo().then(status => (status || []).map(item => ({ text: item.nome, value: item.id.toString() })));
export const updateAditivo = (aditivo: any) => api.put<any>(`aditivos/updateAditivo`, aditivo);
export const insertAditivo = (contratoid: string) => api.put<any>(`aditivos/insertAditivo/${contratoid}`);
export const updateAditivoInfo = (infoAditivo: InfoAditivo) =>
  api.put<InfoAditivo>(`contratos/aditivos/info`, infoAditivo);
export const getAllAditivosByContratoFormatado = (id: any) =>
  getAllAditivosByContrato(id).then(
    aditivo =>
      (aditivo || []).map(a => ({
        id: a.id,
        contratoId: a.contratoId,
        ordem: a.ordem,
        numero: a.numero,
        tipoAditivo: a.tipoAditivo,
        dataTermino: a.dataTerminoFormatada,
        valor: a.valor,
        valorDiferenca: a.valorDiferenca,
      })) as Aditivo[],
  );
export const GetAllAditivosComArquivo = (id: any) => {
  return api.get<AditivoComArquivo[]>(`contratos/getAllAditivosComArquivo/${id}`);
};

export const GetAllAditivosComArquivoSgc = (id: any) => {
  return api.get<AditivoComArquivo[]>(`aditivos/getAllAditivosComArquivoSgc/${id}`);
};

export const GetAllComentarioLinhaBmComAnexo = (id: any) => {
  return api.get<ArquivoContratoAditivo[]>(`contratos/getAllComentarioLinhaBmComAnexo/${id}`);
};

export const GetFileComentarioLinhaBmComAnexo = (id: string, nome: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/contratos/GetFileComentarioLinhaBmComAnexo/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome);
      link.setAttribute('id', id);
      document.body.appendChild(link);
      link.click();
      document.getElementById(id).outerHTML = '';
    }),
  );
};

export const ViewFileComentarioLinhaBmComAnexo = (id: string, nome: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/contratos/GetFileComentarioLinhaBmComAnexo/${id}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(response => {
      let file = undefined;
      let fileUrl = undefined;
      const fileExtension = GetFileExtension(nome);
      if (fileExtension === 'pdf') {
        file = new Blob([response.data], { type: 'application/pdf' });
        fileUrl = URL.createObjectURL(file);
      } else if (imageFormats.includes(fileExtension)) {
        file = new Blob([response.data], { type: 'image/' + fileExtension });
        fileUrl = URL.createObjectURL(file);
      }
      if (fileUrl !== undefined) var resp = window.open(fileUrl);
    }),
  );
};

export const DeleteFileComentarioLinhaBmComAnexo = (id: string) =>
  api.delete(`contratos/deleteFileComentarioLinhaBmComAnexo/${id}`);

export const getAllArquivoContratoAditivoPorAditivoId = (id: any) =>
  api.get<ArquivoContratoAditivo[]>(`aditivos/getAllArquivoContratoAditivoPorAditivoId/${id}`);
export const excluirAquivoAditivoDoContrato = (id: string) =>
  api.delete(`aditivos/excluirArquivoContratoAditivo/${id}`);

export const getAquivoAditivoDoContrato = (anexoId: string, nome: string) => {
  let urlBase = window.location.origin;
  trackPromise(
    Axios.get(urlBase + `/api/aditivos/getAquivoArquivoContratoAditivo/${anexoId}`, {
      responseType: 'blob',
      headers: {
        Authorization: `Bearer ${getJwt()}`,
      },
    }).then(resp => {
      const url = window.URL.createObjectURL(new Blob([resp.data]));
      const link = document.createElement('a');
      link.href = url;
      link.setAttribute('download', nome.replace(/[\[\]]/g,''));
      link.setAttribute('id', anexoId);
      document.body.appendChild(link);
      link.click();
      document.getElementById(anexoId).outerHTML = '';
    }),
  );
};

export const viewAquivoAditivoDoContrato = async (arquivoInicialId, nomeDoArquivo) => {
  var url = window.location.origin + `/api/aditivos/getAquivoArquivoContratoAditivo/${arquivoInicialId}`;
  await Axios.get(url, {
    headers: {
      Authorization: `Bearer ${getJwt()}`,
    },
    responseType: 'blob',
  }).then(response => {
    let file = undefined;
    let fileUrl = undefined;
    const fileExtension = GetFileExtension(nomeDoArquivo);
    if (fileExtension === 'pdf') {
      file = new Blob([response.data], { type: 'application/pdf' });
      fileUrl = URL.createObjectURL(file);
    } else if (imageFormats.includes(fileExtension)) {
      file = new Blob([response.data], { type: 'image/' + fileExtension });
      fileUrl = URL.createObjectURL(file);
    }
    if (fileUrl !== undefined) var resp = window.open(fileUrl);
  });
};
